import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Input from '@Pages/ProfileSettings/Preferences/components/Input';

function PasswordField({ name, label, value, onChange, formErrors, onBlur, isSubmitted }) {
  const [showPassword, setShowPassword] = useState(false);

  const toggleShowPassword = () => setShowPassword(!showPassword);

  return (
    <Input
      key={name}
      id={name}
      name={name}
      label={label}
      type={showPassword ? 'text' : 'password'}
      value={value}
      errorMessages={formErrors}
      onChange={onChange}
      onBlur={onBlur}
      isSubmitted={isSubmitted}
      afterLabelContent={
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        <span className="rx-btn-icon" onMouseDown={toggleShowPassword} onMouseUp={toggleShowPassword}>
          <i className="ss-view" />
        </span>
      }
    />
  );
}

PasswordField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  formErrors: PropTypes.arrayOf(PropTypes.string),
  isSubmitted: PropTypes.bool,
};

export default PasswordField;
